import React, { useEffect } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { OrderType } from 'api/TrackingApi';
import { useMedia } from 'hooks/useMedia';

import { ReactComponent as SecureIcon } from 'assets/icons/vipFeatures/secure.svg';

import { BaseButton, ButtonTypes } from 'components/base/BaseButton';
import { Popup } from 'components/UI/Popup';

import { usePayment3dsPopup } from './hooks/usePayment3dsPopup';

import css from './payment3dsPopup.module.sass';

interface ITrackingProps {
  enabled: boolean;
  orderType: OrderType;
  orderId: string;
}

interface IProps {
  url: string;
  tracking?: ITrackingProps;
  onMount?: () => void;
  onSubmit?: () => void;
  onClose?: () => void;
}

export const Payment3dsPopup: React.FC<IProps> = ({
  url,
  tracking,
  onMount,
  onSubmit,
  onClose,
}) => {
  const { t } = useTranslation('common');

  const { isMobile } = useMedia();

  const { handle3dsPopupMount, handle3dsPopupSubmit, handle3dsPopupClose } =
    usePayment3dsPopup({
      url,
      tracking,
      onMount,
      onSubmit,
      onClose,
    });

  useEffect(() => {
    handle3dsPopupMount();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Popup isFullScreen={isMobile} onClose={handle3dsPopupClose}>
      <div className={css.root}>
        <div className={css.iconHolder}>
          <SecureIcon fill="#DE2600" className={css.icon} />
        </div>

        <p className={css.title}>{t('payment3dsPopup.title')}</p>
        <p className={css.description}>
          <Trans i18nKey="payment3dsPopup.description" ns="common" />
        </p>

        <BaseButton
          type={ButtonTypes.Accent}
          className={css.submitBtn}
          onClick={handle3dsPopupSubmit}
        >
          {t('continue')}
        </BaseButton>
      </div>
    </Popup>
  );
};
